import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper, Fab, Box } from "@mui/material";
import {
    CameraAlt, AccountCircle, CreditCard,
    Stars as StarsIcon
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSettingValueById } from "../../utils/settings";

export default function CustomBottomNav() {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = React.useState(location.pathname);
    const { exhibitor } = useSelector((state) => state);

    React.useEffect(() => {
        setValue(location.pathname);
    }, [location.pathname]);

    const showRaffle = () => {
        const raffle = getSettingValueById("67f653b38e96630fc821ee7b");
        if (!raffle) {
            return false;
        }
        if (exhibitor?.totalScanned >= raffle) {
            return true;
        }
        return false;
    }
    return (
        <>
            <Paper sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', position: "fixed", bottom: 0, left: 0, right: 0, boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 19px 5px;", zIndex: 10
            }}>
                <BottomNavigation
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        navigate(newValue);
                    }}
                    sx={{ height: 60, minWidth: 320 }} // Adjust height
                >
                    {/* <Box maxWidth={'xs'} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}> */}
                    <BottomNavigationAction showLabel label="Passport" value="/" icon={<CreditCard />} />
                    <BottomNavigationAction showLabel label={showRaffle() ? "Raffle" : "Camera"} value={showRaffle() ? "/raffle" : "/camera"}
                        icon={
                            <>
                                <CameraAlt sx={{ opacity: 0 }} />

                                <div style={{
                                    width: 150,
                                    height: 150,
                                    borderRadius: '50%',
                                    // background: 'linear-gradient(to right, #ff7e5f, #feb47b)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '1rem',
                                    // top: -0,
                                    position: "absolute",
                                    transform: "translateY(-30px)"
                                }}>
                                    {showRaffle() ?
                                        <img
                                            src={"https://res.cloudinary.com/dtear00ob/image/upload/v1744177332/projectImages/giftbox-e2a03437-1d5e-4733-9abd-fe2a315746e5.gif"}
                                            style={{
                                                width: "30%",
                                                height: "30%",
                                                objectFit: "contain",
                                            }}
                                        />
                                        :
                                        <Fab color="primary" size="large" onClick={() => navigate("/camera")}>
                                            <CameraAlt />
                                        </Fab>
                                    }
                                </div>
                            </>

                        }
                    />

                    <BottomNavigationAction showLabel label="Me" value="/profile" icon={<AccountCircle />} />
                    {/* </Box> */}
                </BottomNavigation>
            </Paper>
        </>
    );
}
